// VerbumMemo email
export const VERBUM_MEMO_EMAIL = "info@verbum-memo.com";
// Account
export const PREMIUM_ACCOUNT_PRICE = "5,99 €";
export const PREMIUM_ACCOUNT_PRICE_NUMBER = 5.99;
export const MAX_WORDS_FREE_ACCOUNT = 60;

// Date
export const DATE_STRING = "YYYY-MM-DD HH:mm";
export const DATE_STRING_FOR_UI = "DD.MMMM.YYYY HH:mm";
export const DATE_DAYS_FORMAT = "DD.MMMM.YYYY";

// Timers
export const QUESTION_TIMER_SECONDS = 20;
export const TEST_START_TIME = 3;
export const MINUTES_BETWEEN_TESTS = 10;

// Dictionary related
// export const USER_TEST_LIMIT = 250;

// Test related
export const MIN_PERCENTAGE_TO_PASS = 60;
export const TEST_COMPLEATITION_THRESHOLD = 3;
export const TEST_FETCH_LIMIT = 10;

// Collections
export const DICTIONARY_COLLECTION = "dictionary";
export const TESTS_COLLECTION = "tests";
export const WORDS_COLLECTION = "words";
export const STORE_COLLECTION = "store";
export const USERS_COLLECTION = "users";
export const BEGINNER_TESTS_COLLECTION = "beginner-tests";
export const BEGINNER_STORE_TEST_PACK = "beginner-pack";

// Test types
export const TEST_TYPES = [
  "Generic",
  "Family",
  "Days & Months",
  "Body parts",
  "Colors",
  "Food & Drinks",
  "Animals",
  "Nature",
  "Objects",
  "Clothes & Footwear",
  "Numbers",
  "Question words",
  "Adjectives",
  "Verbs",
];

// Supported languages
export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "German" },
  { code: "gb", label: "English" },
  { code: "rs", label: "Serbian" },
  { code: "es", label: "Spanish" },
];

// Countries
export const COUNTRIES = [
  { code: "al", label: "Albanian" },
  { code: "ba", label: "Bosnian" },
  { code: "cn", label: "Chinese" },
  { code: "hr", label: "Croatian" },
  { code: "cz", label: "Czech" },
  { code: "rs", label: "Serbian" },
  { code: "de", label: "German" },
  { code: "es", label: "Spanish" },
  { code: "pt", label: "Portuguese" },
  { code: "fr", label: "French" },
  { code: "fi", label: "Finish" },
  { code: "hu", label: "Hungarian" },
  { code: "it", label: "Italian" },
  { code: "si", label: "Slovenian" },
  { code: "dk", label: "Danish" },
  { code: "in", label: "Hindi" },
  { code: "lt", label: "Lithuanian" },
  { code: "ro", label: "Romanian" },
  { code: "se", label: "Swedish" },
  { code: "jp", label: "Japanese" },
  { code: "ru", label: "Russian" },
  { code: "ph", label: "Filipino" },
  { code: "by", label: "Belarusian" },
  { code: "gr", label: "Greek" },
  { code: "nl", label: "Dutch" },
  { code: "bg", label: "Bulgarian" },
  { code: "no", label: "Norwegian" },
  { code: "pl", label: "Polish" },
  { code: "sk", label: "Slovak" },
  { code: "ua", label: "Ukranian" },
  { code: "mk", label: "Macedonian" },
  { code: "gb", label: "English" },
  { code: "tr", label: "Turkish" },
  { code: "lv", label: "Latvian" },
  { code: "ee", label: "Estonian" },
  { code: "sa", label: "Arabic" },
  { code: "ir", label: "Persian" },
].sort((a, b) => {
  if (b.label < a.label) {
    return 1;
  }
  if (b.label > a.label) {
    return -1;
  }
  return 0;
});

export const BASIC_BENEFITS = [
  "Up to 1 dictionary",
  "Up to 10 tests",
  `Up to ${MAX_WORDS_FREE_ACCOUNT} words`,
];

export const PREMIUM_BENEFITS = [
  "Up to 10 dictionaries",
  "Unlimited tests",
  "Unlimited words",
];
